import { defineStore } from 'pinia'
import { storage } from '@/utils/storage'
import i18n from '@/assets/lang/index';
import MyDialog from '@/plugins/component/MyDialog';
import { queryConfig, queryAppVersion } from '@/api';

export const useSettingsStore = defineStore('settings', {
  state: () => {
    return {
      isSound: storage.get('isSound', false), // 提示音
      isMusic: storage.get('isMusic', false), // 背景音乐
      facebookUrl: '',
      telegramUrl: '',
      onlineService: '',
      downloadPage: '',
      deviceId: '',
      version: '',
      versionCode: '',
      registerCode: '', // 注册邀请码
    }
  },
  getters: {
    downloadUrl: state => {
      let baseUrl = new URL(state.downloadPage);
      baseUrl.searchParams.append("code", state.registerCode);
      return baseUrl.toString();
    }
  },
  actions: {
    set(key, value = true) {
      this[key] = value;
    },
    fetchConfig() {
      queryConfig().then(res => {
        let config = res.data || {}
        this.facebookUrl = config['cs_facebook'];
        this.telegramUrl = config['cs_telegram'];
        this.onlineService = config['cs_online'];
        this.downloadPage = config['download_page'];
      })
    },
    initDeviceInfo() {
      if (window.$bridge) {
        window.$bridge.callHandler('getDeviceInfo', '', result => {
          let data = JSON.parse(result);
          this.deviceId = data.deviceId;
          this.version = data.versionName;
          this.versionCode = data.versionCode;
        });
      }
    },
    checkAppVersion() {
      if (window.$bridge) {
        queryAppVersion().then(res => {
          let { versionCode, downloadUrl } = res.data || {}
          if (!this.versionCode || this.versionCode < versionCode) {
            MyDialog.confirm({
              message: i18n.global.t('msg.versionUpdate'),
            })
            .then(() => {// on confirm
              window.$bridge.callHandler('openBrowser', downloadUrl)
            })
            .catch(() => {});
          }
        })
      }
    },
    setSound(value) {
      this.isSound = value
      storage.set('isSound', value, null)
    },
    setMusic(value) {
      this.isMusic = value
      storage.set('isMusic', value, null)
    },
  }
})
